import styled from 'styled-components';

export const Section = styled.section`
  display: flex;
  padding: 128px 0px;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  align-self: stretch;
  background-color: #F7F5F5;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding: 64px 16px;
    gap: 32px;
  }
`;

export const Heading = styled.h2`
  display: flex;
  max-width: 1120px;
  margin: 0 auto;
  text-align: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  font-size: 48px;
  font-weight: bold;
  color: #222;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    font-size: 36px;
  }
`;

export const ScrollHint = styled.p`
  color: #00B453;
  font-weight: bold;
  text-align: center;
  font-size: 16px;
  display: none;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    display: block;
  }
`;

export const Grid = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 8px;
    gap: 16px;
    justify-content: start;
    max-width: none;
    margin: 0;

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
`;

export const Card = styled.div`
  display: flex;
  width: 380px;
  height: 448px;
  max-width: 1120px;
  padding: 48px 32px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  border-radius: 30px;
  background: #FFF;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);

    @media ${({ theme }) => theme.global.mediaQueries.lg} {
      flex: 0 0 auto; 
    }

  img {
   width: 100px;
   height: 100px;
   margin: 26px;
  }

  div {
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   gap: 32px;
   align-self: stretch;

   h3 {
    font-size: 32px;
    font-weight: bold;
    color: #222;
    margin:0;
  }

  p {
    font-size: 16px;
    color: #222;
    margin:0;
  }

  }

  
`;
